export const AUTH_USER_TOKEN_KEY = "Roots.TokenKey";
